<template>
  <div class="wrap pos-rel">
    <site-header></site-header>
    <products-index standalone="true" />
    <SiteFooter></SiteFooter>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/Footer.vue';
import ProductsIndex from '@/components/ProductsIndex.vue';
export default {
  name: 'Products',
  components: {
    SiteHeader,
    SiteFooter,
    ProductsIndex
  },
  data: function() {
    return {};
  },
  methods: {},
  computed: {}
};
</script>

<style lang="scss"></style>
